export default __webpack_public_path__ + "static/6-7c1f40afcb4cff96d973e0c39d6c9e98.jpg";